import { CancelTripLine, LegalFooter, MDetailRoute, StartTraveling, SummaryAmounts, UiHeaderMyTrips, UiModal, AccessToApp, AveTickets, CercaniasTickets, CancelPstAsk, AveTicketsDelete, CancelLastTripInfo, CancelLastTrip, CancelPstError, UiToast, MTmbDetailActivity, TmbValidationTicket, MGlobickDetailActivity, CancellationConditions, RemoveDiscount, MSixtDetailActivity, ActivityCancelConfirmation, ActivityCancelError, ActivityCancelCorrect, InfoPostPayment, RealTimeTrain, TrainIncidents, UiNewPaginator, CommentsToDriver, } from 'libs/raas-ui-react-components/src/components'
import useToast from 'hooks/useToast';
import React, { useState, useEffect } from 'react';
import { ETypeTransport, IBookingCounts, IData, IDeletePstBody, IMyTripsResponse, ItemType, IBooking, IDetailActivity, SummaryType, IDetailRenting } from './MyTrips.model';
import { calcCurrentPrice, cancelSixtActivity, cancelTMBActivity, deletePSTAVEBooking, getCancellationConditionsCall, getDetailActivityFromBooking, getDetailExperienceFromBooking, getDetailRentingFromBooking, getPaymentInfoData, getTripCardComponentData, getTripDetailRouteComponentData, getTripListCall, usedTMBActivity } from './MyTrips.service';
import { detailTags, getBookingsArray, getFullName, sixtBreakdown, travelsType } from './MyTrips.util';
import { useTranslation } from 'react-i18next';
import useSession from 'hooks/useSession';
import { useNavigate } from 'react-router-dom';
import QRCode from "react-qr-code";
import './MyTrips.scss';
import { CallFailedPageLiterals, desgloseModalLiterals, getFooterLiterals, getInitialCancelModalLiterals, initialAveTicketsLiterals, initialDetailLiterals, initialDetailLiteralsAtom, initialTicketsModalLiterals, NoSessionPageLiterals, NoTripsPageLiterals, tmbValidatorTicketLiterals, tmbCancelTicketLiterals, tmbCancelErrorLiterals, getCancellationConditionsLiterals, tmbUsedConfirmActivityModal, tmbUsedActivityErrorLiterals, tmbUsedActivityLiterals, tmbDetail, sixtDetailVehicle, sixtCancelationError, sixtCancelationCorrect, tmbCancelActivity, sixtDetail, cancelLastTripModal, cancelLastTripInfoModal, getProvisionCardLiterals, initialDriverCommentCanceledLiterals, initialDriverCommentLiterals, DontBuyLiterals } from './MyTrips.literals';
import { openConditionsLink, prepareAvePassengersForModal, prepareCercaniasPassengersForModal, TicketsCall, transformTicket } from '../MyPastTrips/MyPastTrips.service';
import { downloadAveBlob } from 'components/DescargadorPKPass/PKpass';
import { deletePSTCall } from './functions/manageDelete';
import { mock } from './MyTrips.mock';



import { getTokenGlobick, globickMMB } from 'services/util/globick-service';
import { formatPrice } from 'services/util/trips.service';
import { getCancelSixt } from '../SixtFlow/SixtFlow.utils';



import { getConsultIncidence, sheduleInformationCall } from './TrainsIncidents/TrainsIncidents.service';
import { mapTrainSchedulesByNumber } from './TrainsIncidents/TrainsIncidents.util';
import { getRealTimeLiterals, getTrainIncidentsLiterals } from './TrainsIncidents/TrainsIncidents.literals';
import { INotifications } from 'pages/public/Planner/PlannerFlow.model';
import { getNotificationsCall } from 'pages/public/Planner/PlannerFlow.service';



declare const window: any;
export const MyTrips = () => {

    const { openToast } = useToast();

    const [t] = useTranslation('myTrips');
    const [t2] = useTranslation('myPastTrips');
    const [t3] = useTranslation('sixtModals')
    const [t4] = useTranslation('tmbPages')
    const [t5] = useTranslation('tripSelector')
    const [t6] = useTranslation('aveFlow')

    const [notificationsBanner, setNotificationsBanner] = useState({} as INotifications);

    const driverCommentCancelerLiterals = initialDriverCommentCanceledLiterals(t);
    const driverCommentLiterals = initialDriverCommentLiterals(t);
    const footerLiterals = getFooterLiterals(t);
    const { logged, tokenGlobick, setTokenGlobick } = useSession();
    const navigate = useNavigate();

    // *** detail vars
    const [detailLiteralsAtom, setDetailLiteralsAtom] = useState(initialDetailLiteralsAtom(t));
    const [detailLiterals, setDetailLiterals] = useState(initialDetailLiterals(t));
    const [deleteTicketAveLiterals, setDeleteTicketAveLiterals] = useState(null as any);


    const [myTripsTodayDataResponse, setMyTripsTodayDataResponse] = useState({} as any); // datos reales del micro
    const [myTripsFutureDataResponse, setMyTripsFutureDataResponse] = useState({} as any); // datos reales del micro
    const [bookingCounts, setBookingCounts] = useState({ // contador de reservas
        "totalPast": 0,
        "totalToday": 0,
        "totalFuture": 0,
        "pagedPast": 0,
        "pagedToday": 0,
        "pagedFuture": 0
    } as IBookingCounts);

    const [selectTodayTrip, setSelectTodayTrip] = useState(true); // Viaje que hoy tengo

    // *** Data treatment -- Tratamiento de datos para mostrar componentes Stencil
    const [paginatorData, setPaginatorData] = useState([] as any); // UiPaginador
    const [indexCardSelected, setIndexCardSelected] = useState(0); // Posición de la carta seleccionada
    const [detailsSelector, setDetailSelector] = useState(mock.detailData as any[]); // MDetailRoute: Ida / Ida-Vuelta
    const [detailPrice, setDetailPrice] = useState({} as { sum: number, desc: string }); // MDetailRoute: Resumen y pago
    const [tripSummaryData, setTripSummary] = useState(null as any);// Detalle del viaje - Resumen y Pago
    const [tripTotal, setTripTotal] = useState(null as any); // Modal - Ver desglose
    const [tripId, setTripId] = useState('');
    const [typeTransport, setTypeTransport] = useState('');

    const [isTmbSelected, setIsTmbSelected] = useState(false);
    const [isGlobickSelected, setIsGlobickSelected] = useState(false);
    const [isTripSelected, setIsTripSelected] = useState(false);
    const [isSixtSelected, setIsSixtSelected] = useState(false);

    // Activity - TMB
    const [activitySummaryData, setActivitySummary] = useState(null); // Detalle de la actividad - Resumen y Pago
    const [detailActivitySelected, setDetailActivitySelected] = useState<IDetailActivity>();
    const [indexTodayCardSelected, setIndexTodayCardSelected] = useState(0);

    //Experince -Globick
    const [detailExperienceSelected, setDetailExperienceSelected] = useState<IDetailActivity>();

    // Renting- Sixt 
    const [detailSixtSelected, setDetailSixtSelected] = useState<IDetailRenting>();

    let [fromToData, setFromToData] = useState({} as any)

    // *** modals
    const [showModalCancelPst, setShowModalCancelPst] = useState(false);
    const [showSummaryTotal, setShowSummaryTotal] = useState(false);
    const [showBoltModal, setShowBoltModal] = useState(false);
    const [showNoResults, setShowNoResults] = useState(false);
    const [showNoResultsFuture, setShowNoResultsFuture] = useState(false);
    const [showErrorMicro, setShowErrorMicro] = useState(false);
    const [callRecived, setCallRecived] = useState(false);



    // TMB
    const [showValidationTicketActivityModal, setShowValidationTicketActivityModal] = useState(false);
    const [showCancelationConfirmActivityModal, setShowCancelationConfirmActivityModal] = useState(false);
    const [showErrorCancelationActivityModal, setShowErrorCancelationActivityModal] = useState(false);
    const [showCancelationActivityModal, setShowCancelationActivityModal] = useState(false);
    const [showUsedConfirmActivityModal, setShowUsedConfirmActivityModal] = useState(false);
    const [showErrorUsedActivityModal, setShowErrorUsedActivityModal] = useState(false);
    const [showUsedActivityModal, setShowUsedActivityModal] = useState(false);

    // SIXT
    const [showCancelationConfirmSixtModal, setShowCancelationConfirmSixtModal] = useState(false);
    const [showErrorCancelationSixtModal, setShowErrorCancelationSixtModal] = useState(false);
    const [showCancelationSixtModal, setShowCancelationSixtModal] = useState(false);

    //Cercanias Tickets Modal PROVISIONAL
    const [ticketsModalLiterals, setTicketsModalLiterals] = useState(initialTicketsModalLiterals(t2));
    const [showTicketsModal, setShowTicketsModal] = useState(false);

    // CONSIDERAR ELIMINAR
    const [showCancelTicketModal, setShowCancelTicketModal] = useState(false) //Cancelar trayecto ¿eliminar?

    ///////////////// MODALES DE ELIMINAR TRAYECTO /////////////////
    let [PSTPassengerToDelete, setPSTPassengerToDelete] = useState({} as any);

    /* ave */
    const [showAveTicketPassengersCancel, setShowAveTicketPassengersCancel] = useState(false); // Eliminar billete de AVE (2 o más pasajeros)
    const [showAveTicketCancel, setShowAveTicketCancel] = useState(false); // Eliminar billete de AVE (1 pasajero)
    let [avePassengersDelete, setAvePassengersDelete] = useState([]);

    /* cercanias */
    const [showCercaniasTicketCancel, setShowCercaniasTicketCancel] = useState(false); // Eliminar billete de AVE (1 por 1)

    /* taxi/VTC */

    const [showTaxiVTCTripCancel, setShowTaxiVTCTripCancel] = useState(false); // Eliminar transbordo de taxi.
    const [showBoltTripCancel, setShowBoltTripCancel] = useState(false); // Eliminar transbordo de taxi.

    /* Resto PSTs */
    const [showGenericTripCancel, setShowGenericTripCancel] = useState(false); // otros PSTs
    const [pstToDeleteData, setPstToDeleteData] = useState(undefined as any);

    /* Last pst */
    const [showCancelLastTripInfo, setShowCancelLastTripInfo] = useState(false); // Eliminar ultimo transbordo informativo.
    const [showCancelLastTrip, setShowCancelLastTrip] = useState(false); // Eliminar ultimo transbordo.

    /* Error al eliminar pst */
    const [showErrorCancelPst, setShowErrorCancelPst] = useState(false); // Eliminar ultimo transbordo.
    const [showAlreadyCancelledPst, setShowAlreadyCancelledPst] = useState(false); // Ya ha sido cancelado.
    ///////////////// FIN MODALES DE ELIMINAR TRAYECTO /////////////////

    let [cercaniasPassengers, setCercaniasPassengers] = useState([] as any);
    let [tickets, setTickets] = useState([]);

    // Ave tickets Modal PROVISIONAL
    const [aveTicketsModalLiterals, setAveTicketsModalLiterals] = useState(initialAveTicketsLiterals(t2));
    const [showAveTicketsModal, setShowAveTicketsModal] = useState(false);
    let [avePassengers, setAvePassengers] = useState([]);
    let [passBook, setPassBook] = useState([]);
    let [dataLocal, setDataLocal] = useState(null as any);
    let [sumaryLocal, setSumaryLocal] = useState(null as any);

    // Card List
    const [todayCardsList, setTodayCardsList] = useState([] as any);


    const [showSuccessAllDelete, setShowSuccessAllDelete] = useState(false);
    const [showCancellationConditions, setShowCancellationConditions] = useState(false);
    const [priceCancellationConditions, setPriceCancellationConditions] = useState('');
    const cancellationConditionLiterals = getCancellationConditionsLiterals(t)


    const [providerCancellationConditions, setProviderCancellationConditions] = useState('');

    const [dataCodePromo, setDataCodePromo] = useState({ voucherAmount: 0 as any });
    const checkBoltModalLiterals = getProvisionCardLiterals(t);
    const [selectedTrainSchedules, setSelectedSchedules] = useState(null as any)
    const [selectedTrainIncidence, setSelectedTrainIncidence] = useState(null as any)
    const [showRealTimeModal, setShowRealTimeModal] = useState(false)
    const [showTrainIncidenceModal, setShowTrainIncidenceModal] = useState(false)

    const realTimeLiterals = getRealTimeLiterals(t5)
    const trainIncidentsLiterals = getTrainIncidentsLiterals(t5)


    const [incidentTrainList, setIncidentTrainList] = useState([] as any)
    const [supplyCardPrice, setSupplyCardPrice] = useState(0 as number)

    const [todayBookingCounts, setTodayBookingCounts] = useState(0 as number);
    const [futureBookingCounts, setFutureBookingCounts] = useState(0 as number);
    const [showDriverCommentCanceler, setShowDriverCommentCanceler] = useState(false as boolean);

    const [showDriverComment, setShowDriverComment] = useState(false as boolean);
    const [noteDriverComment, setNoteDriverComment] = useState("" as string);

    const [noteDriverCommentCanceler, setNoteDriverCommentCanceler] = useState([] as Array<{ type: string; value: string, id: number }>);


    //Body para los tickets
    let [booking, setBooking] = useState({});
    let [tab, setTab] = useState({ code: 'tab1' });
    let [idLeg, setIdLeg] = useState(null as any);


    let lenguage = "";
    useEffect(() => {
        if (sessionStorage.getItem('raas-language') != lenguage) {
             geyNotifications();
            lenguage = sessionStorage.getItem('raas-language') as any
            setDetailLiteralsAtom(initialDetailLiteralsAtom(t));
            setDetailLiterals(initialDetailLiterals(t));
            setTicketsModalLiterals(initialTicketsModalLiterals(t2));
            setAveTicketsModalLiterals(initialAveTicketsLiterals(t2));
            setActivitySummary({
                ...sumaryLocal,
                literals: {
                    reservationdate: t("literals.reservationdate"),
                    paymethod: t("literals.paymethod"),
                    summaryprice: t("literals.summaryprice"),
                    totalticket: t("literals.totalticket"),
                    cancelationfee: t("literals.cancelationfee"),
                    discounts: t("literals.discounts"),
                    paid: t("literals.paid"),
                    pendingpay: t("literals.pendingpay"),
                    totalamount: t("literals.totalamount"),
                    approx: t("literals.approx"),
                    breakdown: t("literals.breakdown"),
                    cancellationRefund: t("literals.cancellationRefund"),
                    discountsUNKNOWN: t("literals.discountsUNKNOWN"),
                },
            });
            /* PAGINADOR */
            if (!!dataLocal) {
                const paginadorData = getTripCardComponentData(dataLocal, false, t);
                const mappedPaginadorData = paginadorData.map(item => item.outwardJourney);

                const { totalToday } = dataLocal.bookingCounts;

                setPaginatorData(mappedPaginadorData); // Paginador
                selectItemCard(dataLocal, 0, 'outward');
            }
        }
    }, [t, t2]);

    useEffect(() => {
        // _getTripList();
        // _getTripListFuture();
       

    }, [])

    useEffect(() => {
        //Cuando tenemos viajes para today
        if (Object.keys(myTripsTodayDataResponse).length !== 0) {
            selectedDetailRoute(myTripsTodayDataResponse.data, true, 0);
            return;

        } else if (Object.keys(myTripsFutureDataResponse).length !== 0) {
            selectedDetailRoute(myTripsFutureDataResponse.data, false, 0);
            return;
        }


    }, [myTripsTodayDataResponse, myTripsFutureDataResponse])




    const serviceIncidentListMapping = async () => {
        incidentTrainList.forEach((item: any) => {
            getConsultIncidence(
                item,
                (data: any) => {
                    // Mapear y actualizar los datos según la respuesta de la llamada
                    setDetailSelector((prevDetails) => {
                        return prevDetails.map((detail) => {
                            return {
                                ...detail,
                                //...(data && item.tripId === detail.tripId ? { listIncidents: data } : {}),
                                ...(data && detail.icon === "cercanias" ? { listIncidents: data } : {}),
                            };
                        });
                    });
                },
                (err: any) => {
                    console.error("Error al consultar incidencia:", err);
                },
                'false'
            );
        });
    };

    useEffect(() => {
        // con este useEffect detectamos si tenemso trenes para consultar incidencias
        serviceIncidentListMapping();


    }, [incidentTrainList])

    useEffect(() => {
        let data = { detail: { index: 0 } } as CustomEvent
        /*if(todayCardsList.length!==0){
            handleCardPaginatorSelectedToday(data)

        }else if(paginatorData.length!==0){ 
            handleCardPaginatorSelected(data)
        }*/


    }, [paginatorData, todayCardsList])





    const _getTripList = () => {
        setDetailSelector([])
        setCallRecived(false);
        getTripListCall('TODAY', '1',
            //getTripListCall('TODAY,FUTURE','1',
            (response: IMyTripsResponse) => {
                setCallRecived(true);
                setMyTripsTodayDataResponse(response); // Respuesta real del micro.             
                const data: IData = response.data;
                setDataLocal(data)
                setBookingCounts(data.bookingCounts); // Contador de reservas.
                const { totalToday } = data.bookingCounts;
                setTodayBookingCounts(data.pageable.totalPages)
                if (totalToday === 0) {
                    setSelectTodayTrip(false);
                }

                /* No tengo viajes actuales ni futuras */
                if (totalToday === 0) {
                    setShowNoResults(true);
                }
                /* Tengo viajes actuales y/o futuras */
                else {
                    setShowNoResults(false);
                    /* PAGINADOR */
                    const paginadorData = getTripCardComponentData(data, false, t);
                    const filterTodayData = paginadorData.filter(item => item.outwardJourney.chronology === "TODAY");
                    if (filterTodayData.length > 0) {
                        //selectedDetailRoute(data, true, 0);
                    }
                    setTodayCardsList(filterTodayData);
                    /* DETALLE DE LA RESERVA - INCLUYE UPDATE DEL SWITCH OPTIONS RESUMEN PAGO, IDA Y VUELTA */
                    //selectItemCard(data, 0, 'outward');

                }
            },
            (err: any) => {
                if (err === undefined) {
                    setCallRecived(true);
                    setShowErrorMicro(true);
                } else {
                    if (!err.status) {
                        console.warn('My shopping ha petado: ', err);
                    }
                    setCallRecived(true);
                    setShowErrorMicro(true);

                    if (err && err.status !== 401) {
                        // openToast("error", t("literals.errorRequest"), `${err?.status ? ':' + err?.status : ''} ${err?.statusText}`)
                    }
                    else if (err && err[0] && err[0].code) {
                        // openToast("error", t("literals.errorRequest"), `${err[0].code ? ':' + err[0].code : ''} ${err[0].message}`)
                    }
                }

            }
            , "ASC", window.sessionStorage["raas-trip-mock"])
    }
    const _getTripListFuture = () => {
        setDetailSelector([])
        setCallRecived(false);
        getTripListCall('FUTURE', '1',
            (response: IMyTripsResponse) => {
                setCallRecived(true);
                setMyTripsFutureDataResponse(response); // Respuesta real del micro.             
                const data: IData = response.data;
                setDataLocal(data)
                setBookingCounts(data.bookingCounts); // Contador de reservas.
                const { totalFuture } = data.bookingCounts;
                setFutureBookingCounts(data.pageable.totalPages)
                /* No tengo viajes actuales ni futuras */
                if (totalFuture === 0) {
                    setShowNoResultsFuture(true)
                }
                /* Tengo viajes actuales y/o futuras */
                else {
                    setShowNoResultsFuture(false)
                    /* PAGINADOR */
                    const paginadorData = getTripCardComponentData(data, false, t);
                    const filterFutureData = paginadorData.filter(item => item.outwardJourney.chronology === "FUTURE");
                    if (filterFutureData.length > 0) {
                        //selectedDetailRoute(data, false, 0);
                    }

                    setPaginatorData(filterFutureData);

                    /* DETALLE DE LA RESERVA - INCLUYE UPDATE DEL SWITCH OPTIONS RESUMEN PAGO, IDA Y VUELTA */
                    //selectItemCard(data, 0, 'outward');
                }
            },
            (err: any) => {
                if (err === undefined) {
                    setCallRecived(true);
                    setShowErrorMicro(true);
                } else {
                    if (!err.status) {
                        console.warn('My shopping ha petado: ', err);
                    }
                    setCallRecived(true);
                    setShowErrorMicro(true);

                    if (err && err.status !== 401) {
                        // openToast("error", t("literals.errorRequest"), `${err?.status ? ':' + err?.status : ''} ${err?.statusText}`)
                    }
                    else if (err && err[0] && err[0].code) {
                        // openToast("error", t("literals.errorRequest"), `${err[0].code ? ':' + err[0].code : ''} ${err[0].message}`)
                    }
                }

            }
            , "ASC", window.sessionStorage["raas-trip-mock"])
    }


    const handleUsedActivityModal = () => {
        setShowValidationTicketActivityModal(false);
        setShowUsedConfirmActivityModal(true);
    }

    const handleReturnConfirmUsedActivity = () => {
        setShowUsedConfirmActivityModal(false);
        setShowValidationTicketActivityModal(true);
    }

    const handleUsedActivity = () => {
        if (detailActivitySelected) {
            usedTMBActivity(detailActivitySelected.idBooking,
                () => {
                    setShowUsedConfirmActivityModal(false);
                    setShowUsedActivityModal(true);
                },
                () => {
                    setShowUsedConfirmActivityModal(false);
                    setShowErrorUsedActivityModal(true);
                })

        }
    }

    const handleCancelActivityModal = () => {
        setShowCancelationConfirmActivityModal(true);
        setShowValidationTicketActivityModal(false);
    }

    const handleReturnConfirmCancelationActivity = () => {
        setShowCancelationConfirmActivityModal(false);
        setShowValidationTicketActivityModal(true);
    }

    const handleCancelActivity = () => {
        if (detailActivitySelected) {
            cancelTMBActivity(detailActivitySelected.activitySummary.orderId, detailActivitySelected.activitySummary.idBook,
                () => {
                    setShowCancelationActivityModal(true);
                    setShowCancelationConfirmActivityModal(false);
                    _getTripList();
                    _getTripListFuture();
                },
                () => {
                    setShowErrorCancelationActivityModal(true);
                    setShowCancelationConfirmActivityModal(false);
                })
        }
    }

    const handleErrorCancelActivity = () => {
        setShowErrorCancelationActivityModal(false);
        setShowCancelationConfirmActivityModal(true);
    }

    const handleConfirmationCancelationTicket = () => {
        _getTripList();
        _getTripListFuture();
        setShowCancelationActivityModal(false);
    }

    const handleConfirmationCancelSixt = () => {
        setShowCancelationConfirmSixtModal(true);
        window.dataLayer?.push({
            event: "screen_view",
            screen_name: "cancel_SIXT",
            screen_class: "route_tracking_alert"
        })
    }

    const handleCancelSixt = () => {
        if (detailSixtSelected) {
            cancelSixtActivity(detailSixtSelected.tripId, detailSixtSelected.orderId, detailSixtSelected.idBook,
                () => {
                    setShowCancelationSixtModal(true);
                    setShowCancelationConfirmSixtModal(false);

                    _getTripList();
                    _getTripListFuture();
                },
                () => {
                    setShowErrorCancelationSixtModal(true);
                    setShowCancelationConfirmSixtModal(false);
                })
        }
    }

    const handleclickButtonCancelTripModal = (ev: CustomEvent) => {
        if (ev.detail) {
            switch (ev.detail) {
                case 'cancel-button':
                    setPstToDeleteData(null);
                    setPSTPassengerToDelete(null);
                    if (showCercaniasTicketCancel) setShowCercaniasTicketCancel(false);
                    if (showAveTicketCancel) setShowAveTicketCancel(false);
                    if (showTaxiVTCTripCancel) setShowTaxiVTCTripCancel(false);
                    if (showGenericTripCancel) setShowGenericTripCancel(false);
                    if (showBoltTripCancel) setShowBoltTripCancel(false);
                    if (showCancellationConditions) setShowCancellationConditions(false);
                    break;
                case 'continue-button':
                    if (PSTPassengerToDelete?.idBook) {
                        if (showAveTicketCancel || PSTPassengerToDelete?.provider === 'renfe-ave' || providerCancellationConditions === 'renfe-ave') {
                            setTypeTransport("AVE");
                            if (showCancellationConditions) setShowCancellationConditions(false);
                            if (showAveTicketCancel) setShowAveTicketCancel(false);
                            callToDeletePSTAVE(pstToDeleteData, PSTPassengerToDelete?.orderId || pstToDeleteData.orderId.id, [PSTPassengerToDelete?.idBook], PSTPassengerToDelete.ticketId)
                            //callToDeletePST(pstToDeleteData, PSTPassengerToDelete?.orderId || pstToDeleteData.orderId.id, [PSTPassengerToDelete?.idBook]);/
                            setPSTPassengerToDelete({});
                        }
                        if (showCercaniasTicketCancel || PSTPassengerToDelete?.provider === 'renfe-cercanias' || providerCancellationConditions === 'renfe-cercanias') {

                            if (showCercaniasTicketCancel) setShowCercaniasTicketCancel(false);
                            if (showCancellationConditions) setShowCancellationConditions(false);
                            callToDeletePST(pstToDeleteData, PSTPassengerToDelete?.orderId || pstToDeleteData.orderId.id, [PSTPassengerToDelete?.idBook]);
                            setPSTPassengerToDelete({});
                        }
                        else if (showTaxiVTCTripCancel || PSTPassengerToDelete?.provider === 'movitaxi' || providerCancellationConditions === 'movitaxi') {
                            setTypeTransport("Movitaxi");
                            if (showTaxiVTCTripCancel) setShowTaxiVTCTripCancel(false);
                            if (showCancellationConditions) setShowCancellationConditions(false);
                            setShowDriverCommentCanceler(true)
                            //callToDeletePST(pstToDeleteData, PSTPassengerToDelete?.orderId || pstToDeleteData.orderId.id, [PSTPassengerToDelete?.idBook]);
                            //setPSTPassengerToDelete({});
                        }
                        else if (showTaxiVTCTripCancel || PSTPassengerToDelete?.provider === 'karhoo' || providerCancellationConditions === 'karhoo') {
                            setTypeTransport("Karhoo");
                            if (showTaxiVTCTripCancel) setShowTaxiVTCTripCancel(false);
                            if (showCancellationConditions) setShowCancellationConditions(false);
                            callToDeletePST(pstToDeleteData, PSTPassengerToDelete?.orderId || pstToDeleteData.orderId.id, [PSTPassengerToDelete?.idBook]);
                            setPSTPassengerToDelete({});
                        }
                        else if (showBoltTripCancel && PSTPassengerToDelete?.provider === 'bolt' || providerCancellationConditions === 'bolt') {
                            setTypeTransport("Bolt");
                            if (showBoltTripCancel) setShowBoltTripCancel(false);
                            if (showCancellationConditions) setShowCancellationConditions(false);
                            callToDeletePST(pstToDeleteData, PSTPassengerToDelete?.orderId || pstToDeleteData.orderId.id, [PSTPassengerToDelete?.idBook]);
                            setPSTPassengerToDelete({});
                        }
                        else if (showBoltTripCancel && PSTPassengerToDelete?.provider === 'freenow' || providerCancellationConditions === 'freenow') {
                            setTypeTransport("Freenow");
                            if (showBoltTripCancel) setShowBoltTripCancel(false);
                            if (showCancellationConditions) setShowCancellationConditions(false);
                            callToDeletePST(pstToDeleteData, PSTPassengerToDelete?.orderId || pstToDeleteData.orderId.id, [PSTPassengerToDelete?.idBook]);
                            setPSTPassengerToDelete({});
                        }
                        window.dataLayer?.push({
                            event: "select_content",
                            screen_name: "validate_ticket_" + PSTPassengerToDelete?.provider,
                            screen_class: "route_tracking_alert",
                            content_type: 'button',
                            content_name: 'cancel_ticket',
                        });

                    }
                    else if (PSTPassengerToDelete?.ticketId?.idBook) {
                        if (/*showCercaniasTicketCancel ||*/ providerCancellationConditions === 'renfe-cercanias') {
                            if (showCercaniasTicketCancel) setShowCercaniasTicketCancel(false);
                            if (showCancellationConditions) setShowCancellationConditions(false);
                            callToDeletePST(pstToDeleteData, PSTPassengerToDelete?.orderId || pstToDeleteData.orderId.id, [PSTPassengerToDelete?.ticketId?.idBook]);
                            setPSTPassengerToDelete({});
                        }
                    }
                    else if (pstToDeleteData) {
                        if (showGenericTripCancel) setShowGenericTripCancel(false);
                        if (showCancellationConditions) setShowCancellationConditions(false);
                        callToDeletePST(pstToDeleteData); // Se llama a cancelar
                        setPSTPassengerToDelete({});
                    }
                    break;
            }
        }
    }
    const handleCancelLastTripInfoModal = (ev: CustomEvent) => {
        const button = ev?.detail;
        if (button === "cancel-button") {
            setShowCancelLastTripInfo(false);
        }
        else if (button === "continue-button") {
            callToDeletePST(pstToDeleteData); // Se llama a cancelar
        }
    }
    const handleCancelLastTripModal = (ev: CustomEvent) => {
        const button = ev?.detail;
        if (button === "cancel-button") {
            setShowCancelLastTrip(false);
        }
        else if (button === "continue-button") {
            window.dataLayer?.push({
                event: "select_content",
                screen_name: "cancel_trip_" + pstToDeleteData?.transportTypeString,
                screen_class: "route_tracking",
                content_type: 'button',
                content_name: 'cancel_trip ',
            });
            // Lógica eliminar el ultimo pst.
            callToDeletePST(pstToDeleteData); // Se llama a cancelar
        }
    }
    const handleChangeTripInfo = (ev: CustomEvent) => {
        const index = selectTodayTrip ? indexTodayCardSelected : indexCardSelected;
        let data
        if (selectTodayTrip === true) {
            data = myTripsTodayDataResponse.data
        } else {
            data = myTripsFutureDataResponse.data
        }
        if (ev.detail?.code === 'returnJourney') {
            selectItemCard(data, index, 'return');
            let updatedArray = getDetailTrip(data, index, 'return');
            getAvailableTrainsToConsult(updatedArray)

        }
        else if (ev.detail?.code === 'outwardJourney') {
            selectItemCard(data, index, 'outward');
            let updatedArray = getDetailTrip(data, index, 'outward');
            getAvailableTrainsToConsult(updatedArray)

        }


    }
    const handleCancelPstErrorModal = () => {
        setShowErrorCancelPst(false);
    }
    const handleCardPaginatorSelectedToday = (ev: CustomEvent) => {
        setTab({ code: 'tab1' })
        setSelectTodayTrip(true);
        setIndexTodayCardSelected(ev.detail.index);
        selectedDetailRoute(myTripsTodayDataResponse.data, true, ev.detail.index);
    }

    const handleCardPaginatorSelected = (ev: CustomEvent) => {
        setTab({ code: 'tab1' })
        setSelectTodayTrip(false);
        setIndexCardSelected(ev.detail.index);
        selectedDetailRoute(myTripsFutureDataResponse.data, false, ev.detail.index);
        renderPaginatorTodayComponent(todayCardsList)

    }



    const selectItemCard = (data: IData, selectedIndex: number = 0, triptype: 'outward' | 'return' = 'outward') => {
        const dataResponse = { ...data };

        selectedDetailRoute(dataResponse, selectTodayTrip, selectedIndex, triptype);
    }
    // Refactorized

    const selectedDetailRoute = (data: IData, isToday: boolean, selectedIndex: number = 0, triptype: 'outward' | 'return' = 'outward') => {
        const allBookings = data.bookings;
        let filteredBookings: IBooking[];

        if (isToday) {
            filteredBookings = allBookings.filter(item => item.chronology === "TODAY"/* && item.outwardJourney.inProgress*/);
        }
        else {
            filteredBookings = allBookings.filter(item => item.chronology === "FUTURE"/* && !item.outwardJourney.inProgress*/);
        }

        if (filteredBookings[selectedIndex]?.outwardJourney?.experience
            && Object.entries(filteredBookings[selectedIndex]?.outwardJourney?.experience).length !== 0) {
            window.RecoglobickActivitiesMmbWidget.unmount();
            setIsTripSelected(false);
            setIsTmbSelected(false);
            setIsSixtSelected(false);
            setIsGlobickSelected(true);
            const detailExperience = getDetailExperienceFromBooking(filteredBookings[selectedIndex], t, "myTrips");
            setDetailExperienceSelected(detailExperience)
            getTokenGlobick(
                window.sessionStorage["raas-trip-mock"],
                (response: any) => {
                    setTokenGlobick(response);
                    globickMMB(response, detailExperience.activitySummary.orderId, sessionStorage.getItem('raas-language') as any);
                },
                (e: any) => console.log("error", e)
            );


        }
        else if (/*Object.entries(filteredBookings[selectedIndex]?.outwardJourney?.trip).length !== 0*/ filteredBookings[selectedIndex]?.outwardJourney?.trip) {
            setIsTmbSelected(false);
            setIsGlobickSelected(false);
            setIsSixtSelected(false);
            setIsTripSelected(true)
            const _idTrip = filteredBookings[selectedIndex]?.id ? filteredBookings[selectedIndex].id.toString() : '';
            setTripId(_idTrip);
            const detailSelectorData = getTripDetailRouteComponentData(filteredBookings[selectedIndex], t2, false, t6);

            const trip = triptype === 'outward' ? 'outwardJourney' : 'returnJourney';
            if (detailSelectorData.length != 0) {
                const mappedDetailData = detailSelectorData[0][trip];
                setSelectedSchedules(null)
                setIncidentTrainList([])
                //Coger datos de ida y vuelta
                fromToData = detailSelectorData[0];
                setFromToData(detailSelectorData[0]);
                setDetailSelector(mappedDetailData) // Detalle del viaje
                setDetailPrice(calcCurrentPrice(mappedDetailData)); // Detalle de pagos        

                /* Render molecules */
                renderChoicesLiterals(detailSelectorData[0], _idTrip) // choices MDetailRoute ("Payment", "ida", "vuelta")
                //renderPaginatorComponent(0); // cards del paginador
                renderResumePayment(filteredBookings[selectedIndex] as any, selectedIndex, calcCurrentPrice(mappedDetailData), mappedDetailData);// Resumen del pago                              
            }
        }
        else if (filteredBookings[selectedIndex]?.outwardJourney?.activity
            && Object.entries(filteredBookings[selectedIndex]?.outwardJourney?.activity).length !== 0) {
            setIsTripSelected(false);
            setIsGlobickSelected(false);
            setIsSixtSelected(false);
            setIsTmbSelected(true);
            const detailActivity = getDetailActivityFromBooking(filteredBookings[selectedIndex], t, t4, "myTrips");
            setDetailActivitySelected(detailActivity);
        }
        else if (filteredBookings[selectedIndex]?.outwardJourney?.renting
            && Object.entries(filteredBookings[selectedIndex]?.outwardJourney?.renting).length !== 0) {
            setIsTripSelected(false);
            setIsGlobickSelected(false);
            setIsTmbSelected(false);
            setIsSixtSelected(true);
            const detailSixt = getDetailRentingFromBooking(filteredBookings[selectedIndex], t);
            setDetailSixtSelected(detailSixt);
        }


    }
    /* RENDERIZACIÓN DE MOLÉCULAS */
    const renderChoicesLiterals = (info: any, idTrip: string = '') => {
        const literalsdetail = { ...detailLiterals };
        const choices = [{
            code: 'payment',
            text: t("literals.summaryAndPayment")
        }];
        if (info?.outwardJourney && info?.returnJourney == undefined) {
            choices.push({ code: 'outwardJourney', text: t("literals.routeAndTickets") })
        }
        if (info?.returnJourney) {
            choices.push({ code: 'outwardJourney', text: t("literals.go") })
            choices.push({ code: 'returnJourney', text: t("literals.return") })
        }
        literalsdetail.choice = [...choices];

        /* Tag in the header */
        literalsdetail.headerButton =
        {
            "id": idTrip,
            "text": "",
            "type": "",
            "el": "tag"
        }
        setDetailLiterals({ ...literalsdetail })
    }
    const renderPaginatorComponent = (selectedIndex: number, data: any) => {

        /* Actualizo  */
        if (data && data.length > 0) {
            data?.forEach((item: any, index: number) => {
                item.selected = index === selectedIndex;
            });
            setPaginatorData([...data]);
        }
    }

    const renderPaginatorTodayComponent = (data: any) => {

        /* Actualizo  */
        if (data && data.length > 0) {
            data?.forEach((item: any, index: number) => {
                //item.selected = index === selectedIndex;
                item.selected = false;
            });
            setTodayCardsList([...data]);
        }
    }

    const renderResumePayment = (data: IData, selectedIndex: number = 0, selectorprice: any, selectordetail: any) => {
        const { total, summary } = getPaymentInfoData(data, selectorprice, selectordetail, selectedIndex, fromToData, false, t, t2);
        // TODO: quitar mock de literales
        setSumaryLocal(summary)
        setDataCodePromo({ voucherAmount: summary.discountsNoString })
        setTripSummary(
            summary,

        );
        setTripTotal(total);
    }
    const getTicketData = (id: any, books: any, type: any, travellers?: any) => {
        TicketsCall(id, (response: any) => {
            if (type == "cercanias") {
                cercaniasPassengers = prepareCercaniasPassengersForModal(travellers, response.data.tickets || response.data.passBooks, id)

                setCercaniasPassengers(cercaniasPassengers);

                tickets = transformTicket(response.data.tickets, cercaniasPassengers, id);
                setTickets(tickets);
                window.dataLayer?.push({
                    event: "page_view",
                    screen_name: 'validate_ticket_cercanias',
                    screen_class: 'route_tracking',
                });
                setShowTicketsModal(true);

            } else if (type == "ave") {
                avePassengers = prepareAvePassengersForModal(travellers, response.data.passBooks);
                setAvePassengers(avePassengers);
                window.dataLayer?.push({
                    event: "page_view",
                    screen_name: 'passenger_cancel_ticket_ave',
                    screen_class: 'route_tracking',
                });
                setShowAveTicketsModal(true)
            }
        }, (err: any) => {
            const msg = err?.data?.errors[0]?.message || err?.statusText;
            openToast(
                "error",
                t("literals.errorRequest"),
                `${err.status}: ${msg}`
            )
        }, books)
    }
    const manageDeleteLeg = (event: CustomEvent) => {
        const data = event?.detail;

        const pstToDelete = detailsSelector.find((detail: any) => detail.idPst === data.id);

        const { isLastPST, transportType, countPaidTransports, countInformativeTransports } = pstToDelete?.deleteButtonsActions;

        /* Un solo trayecto */
        if (isLastPST === true) {
            setPstToDeleteData(pstToDelete);

            if (countInformativeTransports === 1) {
                setShowCancelLastTripInfo(true);
            } else {
                setShowCancelLastTrip(true);
                window.dataLayer?.push({
                    event: "page_view",
                    screen_name: 'cancel_trip_' + pstToDeleteData?.transportTypeString,
                    screen_class: 'home',
                });
            }

            /*  Multitrayecto */
        } else {
            // Si se elimina un transporte que no es informativo, y es el último PST de pago.
            if (transportType === ETypeTransport.paid && countPaidTransports === 1) {
                setPstToDeleteData(pstToDelete);
                setShowCancelLastTrip(true);
                window.dataLayer?.push({
                    event: "page_view",
                    screen_name: 'cancel_trip_' + pstToDeleteData?.transportTypeString,
                    screen_class: 'home',
                });
            }

            // Si se elimina un transporte informativo y aún hay transportes de pago
            else if (transportType === ETypeTransport.info && countPaidTransports > 0) {
                setShowGenericTripCancel(true);
                setPstToDeleteData(pstToDelete);
                //Modal ¿Seguro que quieres cancelar este trayecto? Recuerda que una vez que canceles el viaje no hay marcha atrás.
                window.dataLayer?.push({
                    event: "page_view",
                    screen_name: 'cancel_route_' + pstToDelete?.transportTypeString,
                    screen_class: 'route_tracking',
                });
            }

            // Si se elimina un transporte informativo y no quedan más transportes de pago
            else if (transportType === ETypeTransport.info && countPaidTransports === 0) {
                if (countInformativeTransports === 1) {
                    setShowCancelLastTripInfo(true);
                } else if (countInformativeTransports > 1) {
                    setShowGenericTripCancel(true);
                }
                setPstToDeleteData(pstToDelete);
            }

            else {
                if (pstToDelete.icon === 'cercanias') {
                    setPstToDeleteData(pstToDelete);
                    setShowCercaniasTicketCancel(true);

                }
                else if (pstToDelete.icon === "ave") {
                    setPstToDeleteData(pstToDelete);
                    setShowAveTicketCancel(true);
                } else {
                    console.warn('CASO POR CUBRIR', pstToDelete?.deleteButtonsActions);
                }
            }
        }

    }


    const callToDeletePSTAVE = (data: IDeletePstBody, orderId?: any, idBooks?: any[], ticketId?: any) => {
        window.dataLayer?.push({
            event: "select_content",
            screen_name: "cancel_route_" + data.transportTypeString as any,
            screen_class: "route_tracking",
            content_type: 'button',
            content_name: 'cancel_route',
        });
        deletePSTAVEBooking({ data, orderId, idBooks, ticketId },
            (response: any) => {

                setShowSuccessAllDelete(true);

                setTimeout(() => {
                    _getTripList();
                    _getTripListFuture();
                }, 2000);

                if (showCancelLastTrip) setShowCancelLastTrip(false);
                if (showCancelLastTripInfo) setShowCancelLastTripInfo(false);
                if (showGenericTripCancel) setShowGenericTripCancel(false);
                if (showAveTicketCancel) setShowAveTicketCancel(false);
                if (showCercaniasTicketCancel) setShowCercaniasTicketCancel(false);
                if (showAveTicketPassengersCancel) setShowAveTicketPassengersCancel(false);
                if (showCancellationConditions) setShowCancellationConditions(false);
            },
            (error: any) => {
                if (showCancelLastTrip) setShowCancelLastTrip(false);
                if (showCancelLastTripInfo) setShowCancelLastTripInfo(false);
                if (showGenericTripCancel) setShowGenericTripCancel(false);
                if (error?.data?.errors[0]?.code === "ERROR_HAFAS_LOGISTICS_BOOKINGS_021") {
                    setDeleteTicketAveLiterals(detailLiterals.errorCancelledKid)
                    setShowAlreadyCancelledPst(true);
                } else {
                    setDeleteTicketAveLiterals(detailLiterals.alreadyCancelled)
                    setShowAlreadyCancelledPst(true);
                }


            });
    }
    const callToDeletePST = (data: IDeletePstBody, orderId?: any, idBooks?: any[], isAve?: boolean, noteDriverComment?: string) => {
        window.dataLayer?.push({
            event: "select_content",
            screen_name: "cancel_route_" + data.transportTypeString as any,
            screen_class: "route_tracking",
            content_type: 'button',
            content_name: 'cancel_route',
        });
        deletePSTCall({ data, orderId, idBooks, noteDriverComment },
            (response: any) => {

                if (response?.data?.journeys?.[0]?.cancelStatus === 'CANCELATION_SUCCESS') {
                    //Si lo que hemos borrado un ave mostramos el toast
                    if (isAve == true) {
                        setShowSuccessAllDelete(true);
                    }
                    setTimeout(() => {
                        _getTripList();
                        _getTripListFuture();
                    }, 2000);
                } else if (response?.data?.journeys?.[0]?.reason === "ALREADY_CANCELED") {
                    setDeleteTicketAveLiterals(detailLiterals.alreadyCancelled)
                    setShowAlreadyCancelledPst(true);
                }

                if (showCancelLastTrip) setShowCancelLastTrip(false);
                if (showCancelLastTripInfo) setShowCancelLastTripInfo(false);
                if (showGenericTripCancel) setShowGenericTripCancel(false);
                if (showAveTicketCancel) setShowAveTicketCancel(false);
                if (showCercaniasTicketCancel) setShowCercaniasTicketCancel(false);
                if (showAveTicketPassengersCancel) setShowAveTicketPassengersCancel(false);
                if (showCancellationConditions) setShowCancellationConditions(false);
            },
            (error: any) => {
                console.log('Algo ha ido mal', error);
                if (showCancelLastTrip) setShowCancelLastTrip(false);
                if (showCancelLastTripInfo) setShowCancelLastTripInfo(false);
                if (showGenericTripCancel) setShowGenericTripCancel(false);
                setShowErrorCancelPst(true);
            });
    }

    const manageButtonFooter = (event: CustomEvent) => {
        setNoteDriverCommentCanceler([])
        // CONTRATOS: CAMBIAR idBooks por entitlementIds
        booking = { entitlementIds: getBookingsArray(event.detail) }; // eso no está bien
        // setBooking({ idBooks: getBookingsArray(event.detail) });

        if (event.detail.event == "cercanias") {
            getTicketData(event.detail.orderId?.id, booking, event.detail.event, event.detail.orderId?.travellers);
            /* Para eliminar el billete de cercanias */
            const bookings = event?.detail?.orderId?.bookings;
            const provider = event?.detail?.orderId?.provider;
            const travellers = event?.detail?.orderId?.travellers;
            let indexTravellers: number = 0;
            const passengers = travellers?.map((item: any, idx: number) => {
                const statusBook = bookings?.find((book: any) => book.idBook == item.bookID)?.status;
                indexTravellers = bookings?.findIndex((book: any) => book.idBook == item.bookID);
                return {
                    id: idx,
                    fullname: `${item?.personalInformation?.customerFullName?.name} ${item?.personalInformation?.customerFullName?.firstSurname}`,
                    idBook: item.bookID,
                    orderId: event?.detail?.orderId?.id,
                    disable: statusBook !== "BOOKED",
                    provider: provider
                }
            })
            /* Se guarda la info del pst a eliminar */
            const pstToDelete = detailsSelector.find((detail: any) => detail.idPst === event.detail.id);
            setPstToDeleteData(pstToDelete);
            setPSTPassengerToDelete({ ...passengers[indexTravellers || 0], provider });


            /* FIN Para eliminar el billete de cercanias */
        }
        else if (event.detail.event == "ave") {
            getTicketData(event.detail.orderId?.id, booking, event.detail.event, event.detail.orderId?.travellers)
        }
        else if (event.detail.event == "cancelTrip") {
            const pstToDelete = detailsSelector.find((detail: any) => detail.idPst === event?.detail?.id);
            setPstToDeleteData(pstToDelete);
            const idPst = event?.detail?.id;
            const bookings = event?.detail?.orderId?.bookings;
            const index = event?.detail?.orderId?.index;
            if (/*idPst == index && */event?.detail?.orderId?.status == "BOOKED" || event?.detail?.orderId?.status == "PARTIALLY_CANCELED") {
                const provider = event?.detail?.orderId?.provider;
                const travellers = event?.detail?.orderId?.travellers;
                const passengers = travellers.map((item: any, idx: number) => {
                    const book = bookings.find((book: any) => book.docoTicketId == item.docoTicketId);
                    return {
                        id: idx,
                        fullname: getFullName(item),
                        idBook: item.bookID,
                        orderId: event?.detail?.orderId?.id,
                        disable: book?.status !== "BOOKED",
                        ticketId: book?.ticketId
                    }
                })
                /*const bodySimple={
                    "bookingId": bookings[0].idBook,
                }*/

                setProviderCancellationConditions(provider)
                switch (provider) {
                    case 'renfe-ave':
                        setAvePassengersDelete(passengers);
                        // Ambos casos OK
                        if (travellers?.length > 1) {
                            setShowAveTicketPassengersCancel(true);
                            window.dataLayer?.push({
                                event: "page_view",
                                screen_name: 'passenger_cancel_ticket_ave',
                                screen_class: 'route_tracking',
                            });
                        } else {
                            setPSTPassengerToDelete({ ...passengers[0], provider });
                            const body = {
                                "bookingId": bookings[0].idBook,
                                "entitlement_id": bookings[0].ticketId,
                            }
                            getCancellationConditionsCall(body, event?.detail.orderId.id,
                                (response: any) => {
                                    setPriceCancellationConditions(formatPrice(response.data?.cancellationInformation?.cancellationFees?.amount / 100))
                                    setShowCancellationConditions(true)
                                },
                                (err: any) => {
                                    console.log("err", err)
                                    openToast("error", t("literals.errorRequest"), `${err.data.errors[0].code ? ':' + err.data.errors[0].code : ''} ${err.data.errors[0].message}`)
                                })
                        }
                        break;
                    case 'renfe-cercanias':
                        setPSTPassengerToDelete({ ...passengers[0], provider });
                        //setShowCercaniasTicketCancel(true);
                        const body = {
                            "bookingId": bookings[0].idBook,
                            "entitlement_id": bookings[0].ticketId,
                        }
                        getCancellationConditionsCall(body, event?.detail.orderId.id,
                            (response: any) => {
                                setPriceCancellationConditions(formatPrice(response.data.cancellationInformation.cancellationFees.amount / 100))
                                setShowCancellationConditions(true)
                            },
                            (err: any) => {
                                console.log("err", err)

                                openToast("error", t("literals.errorRequest"), `${err.data.errors[0].code ? ':' + err.data.errors[0].code : ''} ${err.data.errors[0].message}`)

                            })
                        break;
                    case 'movitaxi':
                        setPSTPassengerToDelete({ ...passengers[0], provider });
                        //setShowTaxiVTCTripCancel(true);
                        setShowCancellationConditions(true)
                        break;
                    case 'karhoo':
                        setPSTPassengerToDelete({ ...passengers[0], provider });
                        let bodyKarhot = {
                            "bookingId": bookings[0].idBook,
                        }
                        getCancellationConditionsCall(bodyKarhot, event?.detail.orderId.id,
                            (response: any) => {
                                setPriceCancellationConditions(formatPrice(response.data.cancellationInformation.cancellationFees.amount / 100))
                                setShowCancellationConditions(true)
                            },
                            (err: any) => {
                                console.log("err", err)

                                openToast("error", t("literals.errorRequest"), `${err.data.errors[0].code ? ':' + err.data.errors[0].code : ''} ${err.data.errors[0].message}`)

                            })
                        break;
                    case 'freenow':
                    case 'bolt':
                        setPSTPassengerToDelete({ ...passengers[0], provider });
                        setShowBoltTripCancel(true);
                        break;
                    default:
                        /* Moto/Patinete/Metro/Bus/Tranvia...: no se cancela (se abordará más adelante en HU-62) */
                        console.log('case no cubierto', provider);
                        break;
                }



            }



            // setShowCancelTicketModal(true)
        }
    }
    const handleAveTicketPassenger = (ev: CustomEvent) => {
        let passBookAux = ev.detail.ticketId;
        setPassBook(passBookAux);
    }


    const handleButtonClick = (ev: CustomEvent) => {

        switch (ev.detail) {
            case "start":
                navigate("/plan");
                break;
            case "login":
                navigate("/login");
                break;
            case "create":
                navigate("/register-user");
                break;
            case "retry":
                navigate(0);
                break;
            case "/my-past-trips":
                navigate(ev.detail);
                break;
            default:
                break;
        }
    };

    const getSheduleInformation = (e: any) => {
        if (e.destinationID !== selectedTrainSchedules?.destinationID) {
            sheduleInformationCall(
                e,
                (data: any) => {
                    setSelectedSchedules(mapTrainSchedulesByNumber(data.data, e))
                    setShowRealTimeModal(true);
                },
                (err: any) => {
                    setSelectedSchedules([])
                    setShowRealTimeModal(true);
                },
                window.sessionStorage["raas-trip-mock"]
            );
        } else {
            setShowRealTimeModal(true);
        }
    }

    const handlePagePaginatorSelected = (ev: CustomEvent, chronology: string) => {
        getTripListCall(
            chronology,
            ev.detail.index,
            (response: IMyTripsResponse) => {
                const data: IData = response.data;
                const paginadorData = getTripCardComponentData(data, false, t);
                switch (chronology) {
                    case 'TODAY':
                        setMyTripsTodayDataResponse(response);
                        const filterTodayData = paginadorData.filter(item => item.outwardJourney.chronology === "TODAY");
                        if (filterTodayData.length > 0) {
                            selectedDetailRoute(data, true, 0);
                        }
                        //setTodayCardsList(filterTodayData);
                        renderPaginatorComponent(0, filterTodayData)
                        break;
                    case 'FUTURE':
                        setMyTripsFutureDataResponse(response);
                        const filterFutureData = paginadorData.filter(item => item.outwardJourney.chronology === "FUTURE");
                        if (filterFutureData.length > 0) {
                            selectedDetailRoute(data, false, 0);
                        }

                        //setPaginatorData(filterFutureData);
                        renderPaginatorComponent(0, filterFutureData)

                        break;
                    default:
                        break;
                }
                selectItemCard(data, 0, 'outward');

            },
            (err: any) => {
                if (err === undefined) {
                    setCallRecived(true);
                    setShowErrorMicro(true);
                } else {
                    if (!err.status) {
                        console.warn('My shopping ha petado: ', err);
                    }
                    setCallRecived(true);
                    setShowErrorMicro(true);

                }
            }
            , "ASC", window.sessionStorage["raas-trip-mock"])
    }

    /* RENDERIZACIÓN DE DISTINTAS VISTAS */
    /**
     * Vista Mis viajes reservados
     * @returns TEMPLATE
     */
    const renderMyBookedTrips = () => {
        const showDetailInfo = detailsSelector?.length > 0;
        let viewDesktopData

        if (window.innerWidth >= 1281) {
            viewDesktopData = false
        } else {
            viewDesktopData = true

        }
        return (
            <div className="container-fluid p-0 my-trips-container">
                <div className="my-trips_body" id="my-trips_resumen">
                    <div className="left-section">
                        <div className="today-list-item">
                        </div>
                        {/* Paginador para días TODAY */}
                        <UiNewPaginator
                            variant={ItemType.MYTRIPS}
                            variantChronology={ItemType.TODAY}
                            //pageNumber={1}     
                            //itemsPage={(5 - bookingCounts?.totalFuture) < 3 ? 3 : 5 - bookingCounts?.totalFuture}                        
                            tagLiterals={{
                                productTag: t("literals.productTag"),
                                travelTag: t("literals.travelTag"),
                                reservTag: t("literals.reservTag")
                            }}
                            tripCardList={todayCardsList}
                            deselect-all={!selectTodayTrip}
                            diffDayLiterals={t("literals.diffDayLiterals")}
                            diffDaysLiterals={t("literals.diffDaysLiterals")}
                            onCardPaginatorSelected={(ev: CustomEvent) => handleCardPaginatorSelectedToday(ev)}
                            onClickRouteBoxItem={(ev: CustomEvent) => handlePagePaginatorSelected(ev, 'TODAY')}
                            totalPages={todayBookingCounts}

                        ></UiNewPaginator>
                        {bookingCounts?.totalFuture >= 1 && bookingCounts?.totalToday >= 1
                            ?
                            <h1 className='my-trips-header'> {t("literals.yourNextTrips")}</h1>
                            :
                            ''
                        }

                        {/* Paginador para días FUTURE */}
                        <UiNewPaginator
                            variant={ItemType.MYTRIPS}
                            variantChronology={ItemType.FUTURE}
                            //pageNumber={1}                        
                            //itemsPage={(5 - bookingCounts?.totalToday) < 2 ? 2 : 5 - bookingCounts?.totalToday}                                                  
                            tagLiterals={{
                                productTag: t("literals.productTag"),
                                travelTag: t("literals.travelTag"),
                                reservTag: t("literals.reservTag")
                            }}
                            tripCardList={paginatorData}
                            deselect-all={selectTodayTrip}
                            diffDayLiterals={t("literals.diffDayLiterals")}
                            diffDaysLiterals={t("literals.diffDaysLiterals")}
                            onCardPaginatorSelected={(ev: CustomEvent) => handleCardPaginatorSelected(ev)}
                            onClickRouteBoxItem={(ev: CustomEvent) => handlePagePaginatorSelected(ev, 'FUTURE')}
                            totalPages={futureBookingCounts}

                        ></UiNewPaginator>
                    </div>
                    <div className={`right-section ${todayCardsList.length > 0 ? 'today' : ''}`}>
                        {isTmbSelected ?
                            <>
                                <MTmbDetailActivity
                                    detailActivity={detailActivitySelected}
                                    onValidationTicketModal={() => { setShowValidationTicketActivityModal(true); setTab({ code: 'tab2' }) }}
                                    variant={ItemType.MYTRIPS}
                                    variantSummary={detailActivitySelected?.variantSummary as any}
                                    tabSelected={tab}
                                    tabs={detailTags(t)}
                                    literals={tmbDetail(t)}
                                    breakdownLiterals={sixtBreakdown(t)}
                                    showBtnSeeCode={(detailActivitySelected?.activitySummary?.statusId !== "PENDING" && detailActivitySelected?.activitySummary.statusId !== "CANCELED")}
                                    isFailedStatus={detailActivitySelected?.activitySummary?.statusId === "FAILED"}
                                    isPastTrip={false}
                                    activityType={travelsType.SIXT}
                                >
                                </MTmbDetailActivity>
                            </>
                            : null}

                        {isGlobickSelected ?
                            <>
                                <MGlobickDetailActivity
                                    detailActivity={detailExperienceSelected}
                                    // onValidationTicketModal={() => (setShowValidationTicketActivityModal(true))}
                                    variant={ItemType.MYTRIPS}
                                    variantSummary={SummaryType.MYACTIVITIES}
                                    tabSelected={tab}
                                    tabs={detailTags(t)}
                                    literals={tmbDetail(t)}
                                    isFailedStatus={detailExperienceSelected?.activitySummary?.statusId === "FAILED"}
                                    activityType={travelsType.GLOBICK}
                                    isPastTrip={false}
                                    viewDesktop={viewDesktopData}
                                >

                                    <div slot="widget">
                                        <div id="recoglobick-activities-mmb" />
                                    </div>
                                </MGlobickDetailActivity>
                            </>
                            : null}

                        {isTripSelected ?
                            <>
                                <MDetailRoute
                                    variant={ItemType.MYTRIPS}
                                    tripId={tripId}
                                    literals={detailLiterals}
                                    detailPrice={detailPrice}
                                    detailLiterals={detailLiteralsAtom}
                                    detailData={detailsSelector}
                                    tripSummary={tripSummaryData}

                                    onTripInfo={(ev: CustomEvent) => handleChangeTripInfo(ev)}
                                    showBuyButton={false}
                                    showDetailInfo={showDetailInfo}
                                    onButtonFooter={(ev) => manageButtonFooter(ev)}
                                    onDeleteLeg={(ev) => manageDeleteLeg(ev)}
                                    onShowOpenModalBolt={(e: any) => { setShowBoltModal(true); setSupplyCardPrice(e.detail.ticket.reservationAmount) }}
                                    onShowModalRealTime={(e) => { getSheduleInformation(e.detail) }}
                                    onOpenModalConsultIncidence={(e) => { setShowTrainIncidenceModal(true); setSelectedTrainIncidence(e?.detail) }}
                                    onOpenbreakdownModal={(e) => { setIdLeg(e.detail); setShowSummaryTotal(true) }}
                                    onOpenModalComment={(e: any) => { setNoteDriverComment(e.detail); setShowDriverComment(true) }}
                                ></MDetailRoute>
                            </>
                            : null}

                        {isSixtSelected ?
                            <>
                                <MSixtDetailActivity
                                    detailActivity={detailSixtSelected}
                                    variant={ItemType.MYTRIPS}
                                    tabSelected={tab}
                                    tabs={detailTags(t)}
                                    literals={sixtDetail(t)}
                                    breakdownLiterals={sixtBreakdown(t)}
                                    vehicleDetailLiterals={sixtDetailVehicle(t)}
                                    onCancelRenting={() => handleConfirmationCancelSixt()}
                                    isPastSixt={false}
                                    activityType={travelsType.SIXT}
                                    isFailedStatus={detailSixtSelected?.rentingSummary?.statusId === "FAILED"}
                                    isPastTrip={false}
                                    contactUrlSixt='https://www.docomobility.com/es/ayuda/preguntas-frecuentes/reservas-y-gestion-del-viaje'
                                >
                                </MSixtDetailActivity>
                            </>
                            : null}
                        {/* Cancelation SIXT Modal Flow */}
                        <UiModal open={showCancelationConfirmSixtModal} blockOverlay={true} onModalClosed={() => setShowCancelationConfirmSixtModal(false)}>
                            <ActivityCancelConfirmation
                                literals={getCancelSixt(t3)}
                                onBackConfirmation={() => setShowCancelationConfirmSixtModal(false)}
                                onCancelationActivity={() => handleCancelSixt()}
                                onCloseCancelActivityModal={() => setShowCancelationConfirmSixtModal(false)}
                                nameCancelActivity={detailSixtSelected?.rentingInfo?.vehicle?.carName}
                            ></ActivityCancelConfirmation>
                        </UiModal>
                        <UiModal open={showErrorCancelationSixtModal} blockOverlay={true}>
                            <ActivityCancelError
                                literals={sixtCancelationError(t)}
                                onOkButton={() => setShowErrorCancelationSixtModal(false)}
                            ></ActivityCancelError>
                        </UiModal>
                        <UiModal open={showCancelationSixtModal} blockOverlay={true}>
                            <ActivityCancelCorrect
                                literals={sixtCancelationCorrect(t)}
                                onCloseModal={() => setShowCancelationSixtModal(false)}
                            />
                        </UiModal>
                        {/* END Cancelation SIXT Modal Flow */}

                        <UiModal open={showValidationTicketActivityModal} onModalClosed={() => setShowValidationTicketActivityModal(false)}>
                            <TmbValidationTicket
                                literals={tmbValidatorTicketLiterals(t)}
                                validationTicketInfo={detailActivitySelected?.activityValidationTicket}
                                onCancelValidationTicket={() => handleCancelActivityModal()}
                                onUsedValidationTicket={() => handleUsedActivityModal()}
                                onCloseValidationTicket={() => setShowValidationTicketActivityModal(false)}
                                activityStatus={detailActivitySelected?.activitySummary?.statusId}
                                isSpecialBus={detailActivitySelected?.variantSummary}
                            >

                                <div slot="codeQr">
                                    {detailActivitySelected?.activityValidationTicket?.qrCode && (
                                        <QRCode
                                            size={256}
                                            style={{ height: "auto", maxWidth: "60%", width: "60%", margin: "0 0 0 4rem" }}
                                            value={detailActivitySelected?.activityValidationTicket?.qrCode?.toString() as any}
                                            viewBox={`0 0 256 256`}
                                        />
                                    )}
                                </div>

                            </TmbValidationTicket>
                        </UiModal>
                        {/* Cancelation TMB Modal Flow */}
                        <UiModal open={showCancelationConfirmActivityModal} blockOverlay={true}>
                            <ActivityCancelConfirmation
                                literals={tmbCancelActivity(t)}
                                onBackConfirmation={() => handleReturnConfirmCancelationActivity()}
                                onCancelationActivity={() => handleCancelActivity()}
                                onCloseCancelActivityModal={() => setShowCancelationConfirmActivityModal(false)}
                                nameCancelActivity={detailActivitySelected?.name}
                            ></ActivityCancelConfirmation>
                        </UiModal>
                        <UiModal open={showErrorCancelationActivityModal} blockOverlay={true}>
                            <ActivityCancelError
                                literals={tmbCancelErrorLiterals(t)}
                                onOkButton={() => handleErrorCancelActivity()}
                            ></ActivityCancelError>
                        </UiModal>
                        <UiModal open={showCancelationActivityModal} blockOverlay={true}>
                            <ActivityCancelCorrect
                                literals={tmbCancelTicketLiterals(t)}
                                onCloseModal={() => handleConfirmationCancelationTicket()}
                            />
                        </UiModal>
                        {/* END Cancelation TMB Modal Flow */}

                        {/* Used Modal Flow */}
                        <UiModal open={showUsedConfirmActivityModal} blockOverlay={true}>
                            <RemoveDiscount
                                onOkModal={() => handleUsedActivity()}
                                literals={tmbUsedConfirmActivityModal(t)}
                                onCancelModal={() => handleReturnConfirmUsedActivity()}
                            />
                        </UiModal>
                        <UiModal open={showErrorUsedActivityModal} blockOverlay={true}>
                            <ActivityCancelError
                                literals={tmbUsedActivityErrorLiterals(t)}
                                onOkButton={() => (setShowErrorUsedActivityModal(false))}
                            ></ActivityCancelError>

                        </UiModal>
                        <UiModal open={showUsedActivityModal} blockOverlay={true}>
                            <ActivityCancelCorrect
                                literals={tmbUsedActivityLiterals(t)}
                                onButtonEventClick={(ev: CustomEvent) => navigate(ev?.detail)}
                                onCloseModal={() => setShowUsedActivityModal(false)}
                            />
                        </UiModal>
                        {/* Used Modal Flow */}
                    </div>
                </div>
            </div>
        )
    }
    /**
    * Vista de "Sin sesión no hay paraíso"
    * @returns TEMPLATE
    */
    const renderNotLogged = () => {
        return (
            <>
                <StartTraveling literals={NoSessionPageLiterals(t2)} onButtonEventClick={(ev) => handleButtonClick(ev)}></StartTraveling>
            </>
        )
    }
    /**
    * Vista de "Se ha desconectado algo"
    * @returns TEMPLATE
    */
    const renderMicroFailed = () => {
        return (
            <>
                <StartTraveling literals={CallFailedPageLiterals(t2)} onButtonEventClick={(ev) => handleButtonClick(ev)}></StartTraveling>
            </>
        )
    }

    /**
    * Vista de "Se ha desconectado algo"
    * @returns TEMPLATE
    */
    const renderNoBuy = () => {
        return (
            <>
                <StartTraveling literals={DontBuyLiterals(t2)} onButtonEventClick={(ev) => handleButtonClick(ev)}></StartTraveling>
            </>
        )
    }

    /**
     * Vista de "Sin viajes a la vista"
     * @returns TEMPLATE
     */
    const renderNoResults = () => {
        return (
            <>
                {showCancelationSixtModal ?
                    <>
                        <UiModal open={showCancelationSixtModal} blockOverlay={true}>
                            <ActivityCancelCorrect
                                literals={sixtCancelationCorrect(t)}
                                onCloseModal={() => setShowCancelationSixtModal(false)}
                            />
                        </UiModal>
                        <StartTraveling literals={NoTripsPageLiterals(t2)} onButtonEventClick={(ev) => handleButtonClick(ev)}></StartTraveling>
                    </>
                    :
                    <StartTraveling literals={NoTripsPageLiterals(t2)} onButtonEventClick={(ev) => handleButtonClick(ev)}></StartTraveling>
                }
            </>
        )
    }

    const handleToastClick = () => {
        setShowSuccessAllDelete(false);
    }



    const cancelarTicketCercanias = () => {
        if (cercaniasPassengers.length === 1) {
            setPSTPassengerToDelete(cercaniasPassengers[0]);
        }
        window.dataLayer?.push({
            event: "select_content",
            screen_name: "validate_ticket_cercanias",
            screen_class: "route_tracking",
            content_type: 'button',
            content_name: 'cancel_ticket',
        });
        window.dataLayer?.push({
            event: "page_view",
            screen_name: 'cancel_cercanias',
            screen_class: 'route_tracking_alert',
        });

        const body = {
            "bookingId": cercaniasPassengers[0].ticketId.idBook,
            "entitlement_id": cercaniasPassengers[0].ticketId.entitlementId,
        }

        getCancellationConditionsCall(body, cercaniasPassengers[0].id,
            (response: any) => {
                setPriceCancellationConditions(formatPrice(response.data.cancellationInformation.cancellationFees.amount / 100))
                setShowCancellationConditions(true)
            },
            (err: any) => {
                console.log("err", err)
                openToast("error", t("literals.errorRequest"), `${err.data.errors[0].code ? ':' + err.data.errors[0].code : ''} ${err.data.errors[0].message}`)
            })
        setProviderCancellationConditions('renfe-cercanias')
        setShowTicketsModal(false);
        //setShowCercaniasTicketCancel(true);
    }

    const cancelarTicketAveMulti = () => {


        const body = {
            "bookingId": PSTPassengerToDelete.idBook,
            "entitlement_id": PSTPassengerToDelete.ticketId,
        }
        getCancellationConditionsCall(body, PSTPassengerToDelete.orderId,
            (response: any) => {
                setPriceCancellationConditions(formatPrice(response.data?.cancellationInformation?.cancellationFees?.amount / 100))
                setShowCancellationConditions(true)
            },
            (err: any) => {
                console.log("err", err)
                openToast("error", t("literals.errorRequest"), `${err.data.errors[0].code ? ':' + err.data.errors[0].code : ''} ${err.data.errors[0].message}`)
            })



    }

    const getDetailTrip = (data: IData, selectedIndex: number = 0, triptype: 'outward' | 'return' = 'outward') => {
        const dataResponse = { ...data };

        return selectedDetailRouteAux(dataResponse, selectTodayTrip, selectedIndex, triptype);
    }

    const selectedDetailRouteAux = (data: IData, isToday: boolean, selectedIndex: number = 0, triptype: 'outward' | 'return' = 'outward') => {
        const allBookings = data.bookings;
        let filteredBookings: IBooking[];

        if (isToday) {
            filteredBookings = allBookings.filter(item => item.chronology === "TODAY"/* && item.outwardJourney.inProgress*/);
        }
        else {
            filteredBookings = allBookings.filter(item => item.chronology === "FUTURE"/* && !item.outwardJourney.inProgress*/);
        }
        if (filteredBookings[selectedIndex]?.outwardJourney?.trip) {
            const detailSelectorData = getTripDetailRouteComponentData(filteredBookings[selectedIndex], t2, false, t6);

            const trip = triptype === 'outward' ? 'outwardJourney' : 'returnJourney';
            if (detailSelectorData.length != 0) {
                const mappedDetailData = detailSelectorData[0][trip];

                return mappedDetailData
            }
        }
    }

    const getAvailableTrainsToConsult = (result: any) => {
        let updatedArray = [...result];
        // Iteramos sobre el array de objetos
        const data = []
        for (let i = 0; i < updatedArray.length; i++) {
            const obj = updatedArray[i];

            //Guardamos aquellos trenes que podemos consultar incidencias
            if (obj.getConsultIncidence) {
                let f = {
                    context: obj.getConsultIncidence.context,
                    tripId: obj.tripId,
                    date: obj.getConsultIncidence.date,
                    nucleo: obj.getConsultIncidence.nucleo
                }
                data.push(f)



            }
        }
        setIncidentTrainList(data)
    }



    /**
     * Metodo que guardamos los comentarios de cancelacion y servicio de cancelacion
     * @param ev 
     */
    const addCommentsToDriver = (ev: any) => {
        const data = ev.detail;
        setNoteDriverCommentCanceler([data]);
        setShowDriverCommentCanceler(false);
        callToDeletePST(pstToDeleteData, PSTPassengerToDelete?.orderId || pstToDeleteData.orderId.id, [PSTPassengerToDelete?.idBook], false, data.value);
        setPSTPassengerToDelete({});
    }


    const geyNotifications = () => {
        getNotificationsCall(
            (data: any) => {
                setNotificationsBanner(data.data.homeMessage)
            },
            () => {
                setNotificationsBanner(null as any)
            }
        );
    }
    return (
        <>
            <UiToast onHandleClickToast={handleToastClick} textTitle={detailLiterals.cancelPstAskAveModal.toast.textTitle} type="success" visible={showSuccessAllDelete} textDesc={detailLiterals.cancelPstAskAveModal.toast.textDesc} ></UiToast>
            <div className="header-my-trips">
                <UiHeaderMyTrips
                    literals={{
                        titlePage: bookingCounts.totalToday > 0 ? t("literals.todayTravel") : t("literals.myTrips"),
                        topRightButton: bookingCounts.totalPast ? { type: "history", text: t("literals.yourPreviousTrips"), id: "/my-past-trips" } : undefined,
                        typeHeader: bookingCounts.totalToday > 0
                    }}
                    onHeaderMyTripsEventClick={(ev) => handleButtonClick(ev)}
                    notificationsBanner={notificationsBanner}
                ></UiHeaderMyTrips>
                {/* {todayCardsList.length > 0 && <div className='trip-today'></div>} */}
                {bookingCounts.totalToday > 0 && <div className='trip-today'></div>}

            </div>
            <div className="my-trips">
                {/* <button onClick={() => cancelarMock()}>Cancelar trayecto mock</button> */}
                {/* { 
                    callRecived && !logged && (renderNotLogged())
                }
                { 
                    callRecived && logged && showErrorMicro && (renderMicroFailed())
                }
                { 
                    callRecived && !showErrorMicro && logged && (myTripsTodayDataResponse?.data?.bookings?.length === 0 && myTripsFutureDataResponse?.data?.bookings?.length === 0) && (renderNoResults())
                }
                { 
                    callRecived && !showErrorMicro && logged && (myTripsTodayDataResponse?.data?.bookings?.length !== 0 || myTripsFutureDataResponse?.data?.bookings?.length !== 0)  && (renderMyBookedTrips())
                } */}
                { 
                    !logged && (renderNotLogged())
                }
                {
                     logged && (renderNoBuy())
                }
           

                {/* MODALES */}
                <UiModal open={showSummaryTotal} onModalClosed={() => setShowSummaryTotal(false)}>
                    <SummaryAmounts
                        literals={desgloseModalLiterals(t)}
                        departure={tripTotal?.departure}
                        arrival={tripTotal?.arrival}
                        onCloseSummaryAmountsEvent={() => setShowSummaryTotal(false)}
                        discountData={dataCodePromo}
                        total={tripSummaryData?.totalamount}
                        typeDiscount={tripSummaryData?.typeDiscount}
                        idLeg={idLeg}
                    ></SummaryAmounts>

                </UiModal>

                <UiModal open={showModalCancelPst} blockOverlay={false}>
                    <CancelTripLine
                        literals={detailLiterals.cancelTripModal}
                        onClickButtonCancelTripModal={(ev: CustomEvent) => handleclickButtonCancelTripModal(ev)}
                    ></CancelTripLine>
                </UiModal>

                {/* CANCELACIÓN PSTs */}

                {/* [ave-renfe] Modal ¿Seguro que quieres cancelar ese billete? */}
                {/* Modal de cancelar todo el viaje completo si es AVE, Avant...*/}
                <UiModal open={showAveTicketCancel} blockOverlay={false}>

                    <CancelPstAsk
                        literals={detailLiterals.cancelPstAskModal}
                        onClickCancelPstButton={(ev: CustomEvent) => handleclickButtonCancelTripModal(ev)}
                    ></CancelPstAsk>
                </UiModal>
                {/* [ave-renfe] Modal ¿Seguro que quieres cancelar ese billete? Más de un pasajero (AVE) */}
                <UiModal open={showAveTicketPassengersCancel} blockOverlay={true}>

                    <AveTicketsDelete
                        literals={detailLiterals.cancelPstAveModal}
                        passengers={avePassengersDelete}
                        onOkDeleteModal={() => {
                            setShowAveTicketPassengersCancel(false);
                            //setShowAveTicketCancel(true);
                            cancelarTicketAveMulti()
                        }}
                        onCloseDeleteModal={() => {
                            setPSTPassengerToDelete({});
                            setShowAveTicketPassengersCancel(false);
                        }}
                        onSelectedPassenger={(ev: CustomEvent) => {
                            setPSTPassengerToDelete(ev.detail); // DUDA: ELIMINAR BILLETE UNO POR UNO (POR PASAJERO)¿?
                        }}
                    ></AveTicketsDelete>
                </UiModal>
                {/* [cercanias-renfe] Modal ¿Seguro que quieres cancelar ese billete? */}
                <UiModal open={showCercaniasTicketCancel} blockOverlay={true}>
                    <CancelPstAsk
                        literals={detailLiterals.cancelPstAskModal}
                        onClickCancelPstButton={(ev: CustomEvent) => handleclickButtonCancelTripModal(ev)}
                    ></CancelPstAsk>
                </UiModal>
                {/* Modal para movitaxi ¿Seguro que quieres cancelar este trayecto? */}
                <UiModal open={showTaxiVTCTripCancel} blockOverlay={false}>
                    <CancelPstAsk
                        literals={detailLiterals.cancelPstTaxiVtcAskModal}
                        onClickCancelPstButton={(ev: CustomEvent) => handleclickButtonCancelTripModal(ev)}
                    ></CancelPstAsk>
                </UiModal>
                {/* Modal genérico ¿Seguro que quieres cancelar este trayecto? */}
                <UiModal open={showGenericTripCancel} blockOverlay={false}>
                    <CancelPstAsk
                        literals={detailLiterals.cancelPstTaxiVtcAskModal}
                        onClickCancelPstButton={(ev: CustomEvent) => handleclickButtonCancelTripModal(ev)}
                    ></CancelPstAsk>
                </UiModal>
                {/* Modal para cancelar el ultimo viaje informativo */}
                <UiModal open={showCancelLastTripInfo} blockOverlay={true}>
                    <CancelLastTripInfo
                        literals={cancelLastTripInfoModal(t)}
                        onClickCancelLastTripInfoButton={(ev: CustomEvent) => handleCancelLastTripInfoModal(ev)}
                    ></CancelLastTripInfo>
                </UiModal>
                {/* Modal para cancelar el ultimo viaje (genérico)*/}
                <UiModal open={showCancelLastTrip} blockOverlay={true}>
                    <CancelLastTrip
                        literals={cancelLastTripModal(t)}
                        onClickCancelLastTripButton={(ev: CustomEvent) => handleCancelLastTripModal(ev)}
                    ></CancelLastTrip>
                </UiModal>
                <UiModal open={showErrorCancelPst} blockOverlay={true}>
                    <CancelPstError
                        literals={detailLiterals.errorCancelation}
                        onClickCancelPstErrorButton={(ev: CustomEvent) => handleCancelPstErrorModal()}
                    ></CancelPstError>
                </UiModal>
                <UiModal open={showAlreadyCancelledPst} blockOverlay={true}>
                    <CancelPstError
                        literals={deleteTicketAveLiterals}//detailLiterals.alreadyCancelled}
                        onClickCancelPstErrorButton={(ev: CustomEvent) => setShowAlreadyCancelledPst(false)}
                    ></CancelPstError>
                </UiModal>
                <UiModal open={showBoltTripCancel} blockOverlay={false}>
                    <CancelPstAsk
                        literals={detailLiterals.cancelPstBoltAskModal}
                        onClickCancelPstButton={(ev: CustomEvent) => handleclickButtonCancelTripModal(ev)}
                    ></CancelPstAsk>
                </UiModal>
                {/* FIN CANCELACIÓN PSTs */}


                <UiModal open={showTicketsModal} blockOverlay={true} onModalClosed={() => setShowTicketsModal(false)}>
                    <CercaniasTickets
                        literals={ticketsModalLiterals.literals}
                        selector={cercaniasPassengers}
                        tickets={tickets}
                        onCloseCercaniasModal={() => setShowTicketsModal(false)}
                        onCancelTicketButton={() => cancelarTicketCercanias()}
                        onConditionsModal={() => openConditionsLink(t)}
                        onSelectedTicket={(ev: CustomEvent) => {
                            setPSTPassengerToDelete(ev.detail);
                        }}
                    >
                    </CercaniasTickets>
                </UiModal>

                <UiModal open={showCancelTicketModal} blockOverlay={true}>
                    <AccessToApp
                        literals={getInitialCancelModalLiterals(t2)}
                        onCancelModal={() => setShowCancelTicketModal(false)}
                        onOkModal={() => setShowCancelTicketModal(false)} />
                </UiModal>

                <UiModal open={showAveTicketsModal} blockOverlay={true}>
                    <AveTickets
                        literals={aveTicketsModalLiterals.literals}
                        passengers={avePassengers}
                        onOpenTicket={() => downloadAveBlob("billete.pkpass", passBook)}
                        onSelectedPassenger={(ev) => handleAveTicketPassenger(ev)}
                        onCloseAveTicketsModal={() => setShowAveTicketsModal(false)}></AveTickets>
                </UiModal>

                <UiModal open={showCancellationConditions} blockOverlay={true}>
                    <CancellationConditions
                        provider={providerCancellationConditions}
                        price={priceCancellationConditions}
                        literals={cancellationConditionLiterals}
                        onClickCancelPstButton={(ev: CustomEvent) => handleclickButtonCancelTripModal(ev)}
                    />
                </UiModal>
                {/* Modal para la bolsa  postPago*/}
                <UiModal open={showBoltModal} blockOverlay={true}>
                    <InfoPostPayment
                        literals={checkBoltModalLiterals}
                        onCancelModal={() => setShowBoltModal(false)}
                        onOkModal={() => setShowBoltModal(false)}
                        supplyCardPrice={supplyCardPrice}

                    />
                </UiModal>

                {/* Modal para los horarios de los trenes */}
                <UiModal open={showRealTimeModal} blockOverlay={true}>
                    <RealTimeTrain
                        onCloseModal={() => setShowRealTimeModal(false)}
                        data={selectedTrainSchedules}
                        literals={realTimeLiterals}
                    />
                </UiModal>

                {/* Modal para las incidencias de los trenes */}
                <UiModal open={showTrainIncidenceModal} blockOverlay={true}>
                    <TrainIncidents
                        onCloseModal={() => setShowTrainIncidenceModal(false)}
                        data={selectedTrainIncidence}
                        literals={trainIncidentsLiterals}
                    />
                </UiModal>


                {/* Modal para escribir el motivo de la cancelacion de taxis */}
                <UiModal
                    open={showDriverCommentCanceler}
                    onModalClosed={() => setShowDriverCommentCanceler(false)}
                    notUseShiftLogic={true}
                >
                    <CommentsToDriver
                        valuesComments={noteDriverCommentCanceler}
                        idDetailSelected={0}
                        literals={JSON.stringify(driverCommentCancelerLiterals)}
                        name={"driverCommentsModal"}
                        onCancelModal={() => setShowDriverCommentCanceler(false)}
                        onCloseModal={() => setShowDriverCommentCanceler(false)}
                        onTextAreaValue={() => { }}
                        variant='myTrips'
                        onSendDriverRequest={(ev: CustomEvent) => addCommentsToDriver(ev)}
                    />
                </UiModal>


                {/* Modal para ver los comentarios de taxis */}
                <UiModal
                    open={showDriverComment}
                    onModalClosed={() => setShowDriverComment(false)}
                    notUseShiftLogic={true}
                >
                    <CommentsToDriver
                        valuesComments={noteDriverComment}
                        idDetailSelected={0}
                        literals={JSON.stringify(driverCommentLiterals)}
                        name={"driverCommentsModal"}
                        onCancelModal={() => setShowDriverComment(false)}
                        onCloseModal={() => setShowDriverComment(false)}
                        onTextAreaValue={() => { "hola" }}
                        variant='myTripsComment'
                        onSendDriverRequest={(ev: CustomEvent) => addCommentsToDriver(ev)}
                    />
                </UiModal>




            </div>
            <div className={`footer-my-trips ${(showErrorMicro || !logged || showNoResults) ? 'fullheight' : 'bottom'}`}>
                <LegalFooter literals={footerLiterals}></LegalFooter>
            </div>
        </>

    )
}
